<div class="card w-100 form-right">
  <div class="back">
    <h2 *ngIf="!draft">{{ "forms.names.addorder" | translate }}</h2>
    <div *ngIf="draft" class="div-title">
      <h2 *ngIf="orderData.client">
        {{ title }}
      </h2>
    </div>
    <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="form">
        <form [formGroup]="form">
          <div *ngIf="account_type == 'broker'">
            <div class="row">
              <div class="col-8">
                <div class="form-section">
                  <div class="mb-3">
                    <label for="broker_reference" class="form-label">{{
                      "inputs.reference" | translate
                      }}</label>
                    <div class="input-group div-copy">
                      <input type="text" class="form-control" id="broker_reference" #inputBrokerReference
                        formControlName="broker_reference" placeholder="{{
                  'inputs.reference' | translate
                }}" required />
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary copy" type="button"
                          (click)="copyToClipboard(inputBrokerReference.value,$event)">
                          <i class="icon-copy"></i>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="form-section">
                  <div class="mb-3">
                    <label for="broker_agent_id" class="form-label">{{
                      "inputs.broker_agent" | translate
                      }}</label>
                    <ng-select formControlName="broker_agent_id" [items]="agentData" bindValue="reference"
                      [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
                      <ng-template ng-label-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
                      <ng-template ng-option-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="account_type == 'supplier'">
            <div class="row">
              <div class="col-8">
                <div class="form-section">
                  <div class="mb-3">
                    <label for="supplier_reference" class="form-label">{{
                      "inputs.reference" | translate
                      }}</label>
                    <div class="input-group div-copy">
                      <input type="text" class="form-control" id="supplier_reference"
                        formControlName="supplier_reference" placeholder="{{
                  'inputs.reference' | translate
                }}" required />
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary copy" #inputSupplierReference type="button"
                          (click)="copyToClipboard(inputSupplierReference.value,$event)">
                          <i class="icon-copy"></i>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="form-section">
                  <div class="mb-3">
                    <label for="supplier_agent_id" class="form-label">{{
                      "inputs.supplier_agent" | translate
                      }}</label>
                    <ng-select formControlName="supplier_agent_id" [items]="agentData" bindValue="reference"
                      [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
                      <ng-template ng-label-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
                      <ng-template ng-option-tmp let-item="item">{{ item.name }} {{ item.lastname }}</ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Vendor,sup,bro,dealer -->
          <div class="form-section">
            <div class="row">
              <div [ngClass]="draft ? 'col-4' : 'col-12'">
                <div class="mb-3">
                  <label for="vendor" class="form-label">{{ "inputs.vendor" | translate }}
                    <!--   <span class="required">*</span> -->
                  </label>
                  <ng-select formControlName="vendor_id" [items]="vendorData" bindValue="reference" bindLabel="name"
                    [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
                  </ng-select>
                </div>
              </div>
              <div class="col-4" *ngIf="draft">
                <div class="mb-3">
                  <label for="vendor" class="form-label">{{ "inputs.vendor_quote_reference" | translate }}
                    <!--   <span class="required">*</span> -->
                  </label>
                  <div class="input-group div-copy">
                    <input type="text" class="form-control" id="vendor_quote_reference" #inputVendorOfertReference
                      formControlName="vendor_quote_reference"
                      placeholder="{{ 'inputs.vendor_quote_reference' | translate }}" required />

                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary copy" type="button"
                        (click)="copyToClipboard(inputVendorOfertReference.value,$event)">
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-4" *ngIf="draft">
                <div class="mb-3">
                  <label for="vendor" class="form-label">{{ "inputs.vendor_reference" | translate }}
                    <!--   <span class="required">*</span> -->
                  </label>
                  <div class="input-group div-copy">
                    <input type="text" class="form-control" id="vendor_reference" #inputVendorReference
                      formControlName="vendor_reference" placeholder="{{ 'inputs.reference' | translate }}"
                      required />

                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary copy" type="button"
                        (click)="copyToClipboard(inputVendorReference.value,$event)">
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>

                </div>
              </div>

            </div>
            <div *ngIf="account_type === 'broker'" class="row">
              <div [ngClass]="draft ? 'col-4' : 'col-12'">
                <div class="mb-3">
                  <label for="supplier" class="form-label">{{ "inputs.supplier" | translate }}
                    <!--   <span class="required">*</span> --></label>
                  <ng-select formControlName="supplier_id" [items]="supplierData" bindValue="reference" bindLabel="name"
                    [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
                  </ng-select>
                </div>
              </div>
              <div class="col-4" *ngIf="draft">
                <div class="mb-3">
                  <label for="supplier" class="form-label">{{ "inputs.supplier_reference" | translate }}
                    <!--   <span class="required">*</span> -->
                  </label>
                  <div class="input-group div-copy">
                    <input type="text" class="form-control" id="supplier_reference" #inputSupplierReference2
                      formControlName="supplier_reference" placeholder="{{ 'inputs.reference' | translate }}"
                      required />

                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary copy" type="button"
                        (click)="copyToClipboard(inputSupplierReference2.value,$event)">
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4" *ngIf="draft">
                <div class="mb-3">
                  <label for="supplier" class="form-label">{{ "inputs.supplier_agent" | translate }}
                    <!--   <span class="required">*</span> -->
                  </label>
                  <input type="text" type="hidden" formControlName="supplier_agent_id" />
                  <input type="text" class="form-control" id="supplier_agent" formControlName="supplier_agent"
                    placeholder="{{ 'inputs.agent' | translate }}" required />

                </div>
              </div>
            </div>
            <div *ngIf="account_type === 'supplier'" class="row">
              <div class="col-4">
                <div class="mb-3">
                  <label for="broker" class="form-label">{{ "inputs.broker" | translate }}
                    <!--   <span class="required">*</span> --></label>
                  <ng-select formControlName="broker_id" [items]="brokerData" bindValue="reference" bindLabel="name"
                    [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
                  </ng-select>
                </div>
              </div>
              <div class="col-4" *ngIf="draft">
                <div class="mb-3">
                  <label for="broker" class="form-label">{{ "inputs.broker_reference" | translate }}
                    <!--   <span class="required">*</span> -->
                  </label>
                  <div class="input-group div-copy">
                    <input type="text" class="form-control" id="broker_reference" #inputBrokerReference2
                      formControlName="broker_reference" placeholder="{{ 'inputs.reference' | translate }}"
                      required />
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary copy" type="button"
                        (click)="copyToClipboard(inputBrokerReference2.value,$event)">
                        <i class="icon-copy"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4" *ngIf="draft">
                <div class="mb-3">
                  <label for="broker" class="form-label">{{ "inputs.broker_agent" | translate }}
                    <!--   <span class="required">*</span> -->
                  </label>
                  <input type="text" type="hidden" formControlName="broker_agent_id" />
                  <input type="text" class="form-control" id="broker_agent" formControlName="broker_agent"
                    placeholder="{{ 'inputs.reference' | translate }}" required />
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="draft">
            <div class="form-section">
              <label for="stage" class="form-label">{{ "inputs.stage" | translate }}
                <span class="required">*</span></label>
              <div class="row">
                <div class="col-6">
                  <div class="mb-3">

                    <ng-select formControlName="stage" [items]="stages" bindValue="key"
                      [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
                      (change)="changeStage($event)">
                      <ng-template ng-label-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
                      <ng-template ng-option-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-6">
                  <div class="btn-next">
                    <button *ngIf="next_ok" type="submit" class="btn btn-primary btn-next_ok"
                      (click)="onSubmitOrderFast(next_ok)"> <i class="icon-next-circle"></i>
                      {{ "badge-status_select-stage."+ next_ok | translate }}
                    </button>

                    <button *ngIf="next_ko" type="submit" class="btn btn-primary btn-next_ko"
                      (click)="onSubmitOrderFast(next_ko)"> <i class="icon-pause-circle"></i>
                      {{ "badge-status_select-stage."+ next_ko | translate }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="mb-3">
                  <label for="notes" class="form-label">{{
                    "inputs.addnote" | translate
                    }}</label>
                  <textarea class="form-control textarea150" id="notes" rows="5" formControlName="notes"></textarea>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="div-form"></div>
    <div class="btn-send d-flex align-items-center justify-content-end w-100 ml-4"
      *ngIf="activeFormTab != 'timeline'">

        <button *ngIf="!draft" type="submit" class="btn btn-primary btn-primary-form" (click)="onSubmit()">

          <span *ngIf="role == 'Sales'">
            {{ "buttons.createsql" | translate }}
          </span>
          <span *ngIf="role != 'Sales'">
            {{ "buttons.createdraft" | translate }}
          </span>
        </button>

    </div>
  </div>
</div>
